/* Shared behaviour for the landing page sections: scroll reveal and the mobile order bar. Safe to load more than once. */
(function () {
  if (window.__lpLanding) return;
  window.__lpLanding = true;

  var hasIO = 'IntersectionObserver' in window;
  var revealIO = null;
  var stickyIOs = [];

  function reveal() {
    var els = document.querySelectorAll('.n-reveal:not(.is-in)');
    if (!hasIO) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    els.forEach(function (el) { revealIO.observe(el); });
  }

  function sticky() {
    stickyIOs.forEach(function (o) { o.disconnect(); });
    stickyIOs = [];
    var root = document.documentElement;
    var bar = document.getElementById('n-sticky');
    var hero = document.querySelector('.n-hero');
    var packs = document.getElementById('n-packs');
    if (!bar || !hero || !hasIO) { root.classList.remove('n-sticky-on'); return; }
    var heroGone = false, packsVisible = false;
    function sync() {
      var on = heroGone && !packsVisible;
      bar.classList.toggle('is-on', on);
      root.classList.toggle('n-sticky-on', on);
    }
    var a = new IntersectionObserver(function (e) { heroGone = !e[0].isIntersecting; sync(); });
    a.observe(hero);
    stickyIOs.push(a);
    if (packs) {
      var b = new IntersectionObserver(function (e) { packsVisible = e[0].isIntersecting; sync(); });
      b.observe(packs);
      stickyIOs.push(b);
    }
  }

  function init() { reveal(); sticky(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: sections are re-rendered when edited, added, moved or removed. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { setTimeout(sticky, 0); });
})();
